import React from 'react';
import PropTypes from 'prop-types';
import Counter from "./components/Counter";
import CounterCentralTimer from "./components/CounterCentralTimer";
import CounterTimer from "./components/CounterTimer";
import Timer from "./components/Timer";
import TimerGroup from "./components/TimerGroup";
import PokerCards from "./components/PokerCards";
import CounterTriathlon from "./components/CounterTriathlon";

const DashboardItem = ({ config, workoutGroup, groupID, type }) => {
    switch (config.Type) {
        case 'Counter':
            return (
                <Counter
                    workoutGroup={workoutGroup}
                    groupID={groupID}
                    workoutPartID={config.ID}
                    config={config}
                    type={type}
                />
            )
        case 'CounterTriathlon':
            return (
                <CounterTriathlon
                    workoutGroup={workoutGroup}
                    groupID={groupID}
                    workoutPartID={config.ID}
                    config={config}
                    type={type}
                />
            )
        case 'CounterCentralTimer':
            return (
                <CounterCentralTimer
                    workoutGroup={workoutGroup}
                    groupID={groupID}
                    workoutPartID={config.ID}
                    config={config}
                    type={type}
                />
            )
        case 'CounterTimer':
            return (
                <CounterTimer
                    workoutGroup={workoutGroup}
                    groupID={groupID}
                    workoutPartID={config.ID}
                    config={config}
                    type={type}
                />
            )
        case 'Timer':
            return (
                <Timer
                    workoutGroup={workoutGroup}
                    groupID={groupID}
                    workoutPartID={config.ID}
                    config={config}
                    type={type}
                />
            )
        case 'TimerGroup':
            return (
                <TimerGroup
                    workoutGroup={workoutGroup}
                    groupID={groupID}
                    workoutPartID={config.ID}
                    config={config}
                    type={type}
                />
            )
        case 'PokerCards':
            return (
                <PokerCards
                    workoutGroup={workoutGroup}
                    groupID={groupID}
                    workoutPartID={config.ID}
                    config={config}
                    type={type}
                />
            )
        default:
            return <>Typ nicht definiert</>
    }
}

DashboardItem.propTypes = {}

export default DashboardItem;
